import React from 'react';
import classNames from 'classnames';
import { QuestionIcon, UserIcon } from 'twain-sport-fe-mono/icons';
import classes from './Avatar.module.scss';

interface IProps {
    src: string;
    size?: 'normal' | 'small' | 'tiny';
    className?: string;
}

export const Avatar: React.FC<IProps> = (props) => {
    const [isLoaded, updateLoaded] = React.useState(false);

    return (
        <div
            className={classNames(
                classes.container,
                props.size ? classes[props.size] : null,
                {
                    [classes.loaded]: isLoaded,
                },
                props.className,
            )}
        >
            {props.src ? (
                <>
                    {!isLoaded && <UserIcon className={classes.icon} />}
                    <img
                        src={props.src}
                        alt="avatar"
                        className={classes.img}
                        onLoad={() => updateLoaded(true)}
                    />
                </>
            ) : (
                <QuestionIcon className={classNames(classes.icon, classes.questionIcon)} />
            )}
        </div>
    );
};
